/**
 * Componente de Gráfico de Linha
 * Mostra projeção de fluxo de caixa ao longo do tempo
 * 
 * IMPORTANTE: Execute 'npm install recharts' antes de usar este componente
 */

import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useTheme } from '../context/ThemeContext';

const GraficoLinha = ({ data }) => {
  const { isDarkMode } = useTheme();

  const formatarMoeda = (valor) => {
    return `R$ ${parseFloat(valor || 0).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  // Dados de exemplo para fluxo de caixa (30 dias)
  // Substitua isso pelos dados reais do backend
  const dadosFluxo = data || [
    { dia: '1', saldo: 10000 },
    { dia: '5', saldo: 12000 },
    { dia: '10', saldo: 15000 },
    { dia: '15', saldo: 14000 },
    { dia: '20', saldo: 16000 },
    { dia: '25', saldo: 18000 },
    { dia: '30', saldo: 20000 },
  ];

  return (
    <ResponsiveContainer width="100%" height={180}>
      <LineChart data={dadosFluxo} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={isDarkMode ? '#404040' : '#e0e0e0'} />
        <XAxis 
          dataKey="dia" 
          tick={{ fill: isDarkMode ? '#a0a0a0' : '#6c757d', fontSize: 11 }}
          stroke={isDarkMode ? '#404040' : '#dee2e6'}
          label={{ value: 'Dia', position: 'insideBottom', offset: -5, fill: isDarkMode ? '#a0a0a0' : '#6c757d' }}
        />
        <YAxis 
          tick={{ fill: isDarkMode ? '#a0a0a0' : '#6c757d', fontSize: 11 }}
          stroke={isDarkMode ? '#404040' : '#dee2e6'}
          tickFormatter={formatarMoeda}
        />
        <Tooltip 
          formatter={formatarMoeda}
          contentStyle={{
            backgroundColor: isDarkMode ? '#2d2d2d' : '#ffffff',
            border: `1px solid ${isDarkMode ? '#404040' : '#dee2e6'}`,
            borderRadius: 8,
            color: isDarkMode ? '#e0e0e0' : '#333333'
          }}
        />
        <Line 
          type="monotone" 
          dataKey="saldo" 
          stroke="#007bff" 
          strokeWidth={2}
          dot={{ fill: '#007bff', r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default GraficoLinha;
